import { useEffect, useState } from 'react';

export const PREVIEW_PANEL_SLIDE_MS = 300;

/**
 * Mount/unmount with a one-frame delay so enter transitions can run (width / translate).
 */
export function usePreviewPanelSlide(open: boolean): { mounted: boolean; shown: boolean } {
  const [mounted, setMounted] = useState(open);
  const [shown, setShown] = useState(open);

  useEffect(() => {
    if (open) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- mount panel before rAF-driven enter transition
      setMounted(true);
      let innerId = 0;
      const outerId = requestAnimationFrame(() => {
        innerId = requestAnimationFrame(() => setShown(true));
      });
      return () => {
        cancelAnimationFrame(outerId);
        cancelAnimationFrame(innerId);
      };
    }
    setShown(false);
    return undefined;
  }, [open]);

  useEffect(() => {
    if (!open && mounted && !shown) {
      const t = window.setTimeout(() => setMounted(false), PREVIEW_PANEL_SLIDE_MS);
      return () => clearTimeout(t);
    }
    return undefined;
  }, [open, mounted, shown]);

  return { mounted, shown };
}
